
import { defineComponent, PropType, toRefs } from 'vue';
import { Post } from '@/types';

export default defineComponent({
    name: 'Post',

    props: {
        post: {
            type: Object as PropType<Post>,
            required: true,
        },
    },

    setup(props) {
        const { post } = toRefs(props);
        const postUrl = post.value.title.split(' ').join('-');

        return { postUrl };
    },
});
